import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Career from './pages/Career';
import Partnership from './pages/Partnership';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col ">
        <Navigation />
        <main className="min-h-screen overflow-x-clip">
          <div className=" ">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/career" element={<Career />} />
              <Route path="/partnership" element={<Partnership />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<Blog />} />
              <Route path="/early-adopters" element={<Pricing />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
